import React from 'react';

interface Props {
    color?: string;
}

export const SpinnerIcon = ({ color = 'white' }: Props) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 100 100'
            style={{
                width: '100%',
                height: '100%',
                animation: 'spin 0.8s linear infinite',
            }}
        >
            <circle
                cx='50'
                cy='50'
                r='35'
                stroke={color}
                strokeWidth='8'
                fill='none'
                strokeLinecap='round'
                strokeDasharray='100 150'
            />
        </svg>
    );
};
